import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-ask-for-feedback',
  templateUrl: './dialog-ask-for-feedback.component.html',
  styleUrls: ['./dialog-ask-for-feedback.component.scss']
})
export class DialogAskForFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
